module.exports = __webpack_public_path__ + "assets/language-squares/en-e05d6acac73eba394237c011e379c6ea.jpg";